export const SET_CLIPBOARD_BEING_CUT = 'SET_BEING_CUT'
export const SET_CLIPBOARD_NEW_PARENT = 'SET_NEW_PARENT'
export const SET_CLIPBOARD_OLD_PARENT = 'SET_OLD_PARENT'


